import * as actionTypes from '../actionTypes/phoneNumberCapture';

export function checkPhoneNumberExpired() {
  return { type: actionTypes.CHECK_PHONE_NUMBER_EXPIRED };
}

export function closePhoneNumberCapture(expiry) {
  return { type: actionTypes.CLOSE_PHONE_NUMBER_CAPTURE, expiry };
}

export function phoneNumberCaptureSubmit(data) {
  return { type: actionTypes.PHONE_NUMBER_CAPTURE_SUBMIT, data };
}

export function whatsappCapturePhoneNumber() {
  return { type: actionTypes.ONLY_PHONE_CAPTURE_SUBMIT };
}
